import { EnvironmentProviders, inject, makeEnvironmentProviders } from '@angular/core';
import { ROUTES, Route, RouterFeatures, provideRouter } from '@angular/router';

import { ROUTE_EXPLORATION } from '../route-exploration.token';

/**
 * @experimental
 *
 * Extends functionality or `providerRouter` from `@angular/router`.
 * Allows setting up the routes with awareness of context
 *
 * @remark
 * Its primary use it to prevent the application from accessing routes during the route exploration phase which may
 * require context or data which is not available during that phase.
 *
 * @param routes
 * @param features
 * @param explorationRoutes
 * @returns A set of providers to set up a Router.
 */
export function provideContextAwareRouter(
    routes: Route[],
    features: RouterFeatures[],
    explorationRoutes: Route[] = [{ path: '**', children: [] }],
): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: ROUTES,
            useFactory: () => (inject(ROUTE_EXPLORATION) ? explorationRoutes : routes),
            multi: true,
        },
        provideRouter([], ...features),
    ]);
}
